import ChannelRepository from './Admin/ChannelRepository';
import InstanceRepository from './InstanceRepository';
import MediaRepository from './MediaRepository';
import ChapterRepository from './ChapterRepository';
import HistoryRepository from './HistoryRepository';
import InstanceMemberRepository from './InstanceMemberRepository';
import InstanceGroupRepository from './InstanceGroupRepository';
import ChannelMemberRepository from './ChannelMemberRepository';
import ChannelSettingsRepository from './ChannelSettingsRepository';
import ChapterLiveRepository from './ChapterLiveRepository';
import LiveModeRepository from './LiveModeRepository';
import EventRepository from './EventRepository';
import CategoryRepository from './CategoryRepository';
import DeviceControlRepository from './DeviceControlRepository';
import DataImporterRepository from './Admin/DataImporterRepository';
import InstanceExportRepository from './InstanceExportRepository';

const repositiories = {
  adminChannels: ChannelRepository,
  instances: InstanceRepository,
  media: MediaRepository,
  chapters: ChapterRepository,
  chaptersLive: ChapterLiveRepository,
  history: HistoryRepository,
  instanceMembers: InstanceMemberRepository,
  instanceGroups: InstanceGroupRepository,
  channelMembers: ChannelMemberRepository,
  channelSettings: ChannelSettingsRepository,
  livemode: LiveModeRepository,
  events: EventRepository,
  categories: CategoryRepository,
  devicecontrol: DeviceControlRepository,
  dataimporter: DataImporterRepository,
  instanceExport: InstanceExportRepository,
};


export const RepositoryFactory = {
  get: name => repositiories[name],
};
